interface MayorActionButtonProps {
  label: string;
  onClick: () => void;
  /** Default: city-hall dialog mark. Use `emoji` for text icons instead. */
  iconSrc?: string;
  emoji?: string;
  disabled?: boolean;
  opacity?: number;
  cursor?: string;
}

/** Shared pill-shaped action button used in the main town-hall menu. */
function MayorActionButton({
  label,
  onClick,
  iconSrc = "/game-assets/nscene-general/city-hall-dialog-mark.svg",
  emoji,
  disabled,
  opacity = 1,
  cursor = "pointer",
}: MayorActionButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="flex w-fit items-center justify-center gap-[10px] self-end rounded-xl border border-brand bg-white px-[18px] py-[10px]"
      style={{
        cursor,
        opacity,
      }}
    >
      {emoji ? (
        <div className="text-[16px] leading-[16px]">{emoji}</div>
      ) : (
        <img
          src={iconSrc}
          alt=""
          className="h-[16px] w-[9px] shrink-0"
        />
      )}
      <div
        className="text-left [font-family:Lato,sans-serif] text-[16px] leading-[22px] font-normal text-text-dark"
      >
        {label}
      </div>
    </button>
  );
}

export default MayorActionButton;
